export const ADJUST_BALANCE_UNITS = {
  text: "events",
  voice: "minutes",
  data: "MB",
};

export const formatAdjustAmount = (balanceType, amount) => {
  if (amount === null || amount === undefined) return "";
  const unit = ADJUST_BALANCE_UNITS[balanceType];
  return unit ? `${amount} ${unit}` : `${amount}`;
};

// PWG reports talk balance in seconds and data balance in bytes.
export const formatPwgBalance = (balanceType, value) => {
  if (value === null || value === undefined || value === "") return "";
  const number = Number(value);
  if (Number.isNaN(number)) return `${value}`;
  const divisor = { voice: 60, data: 1024 * 1024 }[balanceType] || 1;
  const converted = Math.round((number / divisor) * 100) / 100;
  return formatAdjustAmount(balanceType, converted);
};
